var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "printer_light",
    transform: "translate(-665.533)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 25,
    height: 25,
    transform: "translate(665.533)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "printer_1_",
    "data-name": "printer (1)",
    transform: "translate(669 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51259",
    "data-name": "Group 51259",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51258",
    "data-name": "Group 51258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46141",
    "data-name": "Path 46141",
    d: "M14.521,170.667H2.479A2.35,2.35,0,0,0,0,172.854v3.75a1.007,1.007,0,0,0,1.063.938H3.9a.315.315,0,1,0,0-.625H1.063a.335.335,0,0,1-.354-.313v-3.75a1.679,1.679,0,0,1,1.771-1.562H14.521a1.679,1.679,0,0,1,1.771,1.562v3.75a.335.335,0,0,1-.354.313H13.1a.315.315,0,1,0,0,.625h2.833A1.007,1.007,0,0,0,17,176.6v-3.75A2.35,2.35,0,0,0,14.521,170.667Z",
    transform: "translate(0 -170.667)",
    fill: "#374955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51261",
    "data-name": "Group 51261",
    transform: "translate(3.542 8.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51260",
    "data-name": "Group 51260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46142",
    "data-name": "Path 46142",
    d: "M116.229,298.667H107.02a.335.335,0,0,0-.354.313V304.6a.335.335,0,0,0,.354.313h9.208a.335.335,0,0,0,.354-.312v-5.625A.335.335,0,0,0,116.229,298.667Zm-.354,5.625h-8.5v-5h8.5Z",
    transform: "translate(-106.666 -298.667)",
    fill: "#374955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51263",
    "data-name": "Group 51263",
    transform: "translate(3.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51262",
    "data-name": "Group 51262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46143",
    "data-name": "Path 46143",
    d: "M116.229,0H107.02a.335.335,0,0,0-.354.313v5a.335.335,0,0,0,.354.313h9.208a.335.335,0,0,0,.354-.313v-5A.335.335,0,0,0,116.229,0Zm-.354,5h-8.5V.625h8.5Z",
    transform: "translate(-106.666)",
    fill: "#374955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51265",
    "data-name": "Group 51265",
    transform: "translate(4.958 12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51264",
    "data-name": "Group 51264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46144",
    "data-name": "Path 46144",
    d: "M156.062,426.667h-6.375a.315.315,0,1,0,0,.625h6.375a.315.315,0,1,0,0-.625Z",
    transform: "translate(-149.333 -426.667)",
    fill: "#374955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51267",
    "data-name": "Group 51267",
    transform: "translate(4.958 10.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51266",
    "data-name": "Group 51266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46145",
    "data-name": "Path 46145",
    d: "M156.062,362.667h-6.375a.315.315,0,1,0,0,.625h6.375a.315.315,0,1,0,0-.625Z",
    transform: "translate(-149.333 -362.667)",
    fill: "#374955"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterLight);
export default __webpack_public_path__ + "static/media/printer_light.0bc35441716efdf8ad9408db2e73a9f5.svg";
export { ForwardRef as ReactComponent };